import {
  FormControl,
  FormHelperText,
  InputLabel,
  MenuItem,
  Select,
  SelectChangeEvent,
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import LoadingAdornment from 'pages/Distribution/components/LoadingAdornment';
import distributionApi from 'services/api/distribution';
import {
  selectGenres,
  selectReleaseGenre,
} from 'services/store/distribution/selectors';
import { ReleaseFieldType } from 'services/store/distribution/types';

type PropsType = {
  releaseId: string;
};

const GenreSelector = ({ releaseId }: PropsType) => {
  const { t } = useTranslation();

  const genres = useSelector(selectGenres);

  const genre = useSelector(selectReleaseGenre(releaseId));
  const { data, loading, error } = genre;

  const [updateRelease] = distributionApi.useUpdateReleaseMutation();

  return (
    <FormControl fullWidth error={!!error} disabled={loading}>
      <InputLabel id="genre-label">
        {t(`distribution:details:fields:${ReleaseFieldType.Genre}:placeholder`)}
      </InputLabel>
      <Select
        labelId="genre-label"
        label={t(
          `distribution:details:fields:${ReleaseFieldType.Genre}:placeholder`
        )}
        value={data?.id ?? ''}
        endAdornment={loading && <LoadingAdornment />}
        inputProps={{ ...(loading && { IconComponent: () => null }) }}
        onChange={(event: SelectChangeEvent) => {
          const { value: newValue } = event.target;
          updateRelease({
            releaseId,
            field: ReleaseFieldType.Genre,
            value: newValue,
          });
        }}
      >
        {genres.map(({ id, name }) => (
          <MenuItem key={id} value={id}>
            {name}
          </MenuItem>
        ))}
      </Select>
      {error && <FormHelperText>{error.message}</FormHelperText>}
    </FormControl>
  );
};

export default GenreSelector;
